<template>
  <div class="ducument-item">
    <div class="ducument--header">
      <div class="ducument--title-container">
        <h3 class="ducument--title" @click="handleView">
          {{ ducument.title || '-' }}
        </h3>
      </div>
      <div
        class="ducument-tag"
        :style="{
          backgroundColor: getTagColor(ducument.index).bg,
          color: getTagColor(ducument.index).text,
        }"
      >
        {{ ducument.status || '-' }}
      </div>
      <div class="ducument-code">
        {{ ducument.ducumentCode || '-' }}
      </div>
    </div>
    <!-- <div class="ducument--ai-summary" :title="ducument.aiSummary || ''">
      AI摘要:
      {{ getTruncatedSummary(ducument.aiSummary || '-') }}
    </div> -->

    <div class="ducument--info">
      <div class="info-item flex-space-between">
        <div class="info-row">
          <span class="info-value">版本：{{ ducument.version || '-' }}</span>
        </div>
        <div class="info-row">
          <span class="info-value">目录：{{ ducument.category || '-' }}</span>
        </div>
        <div class="info-row">
          <svg
            class="info-icon"
            xmlns="http://www.w3.org/2000/svg"
            width="14"
            height="14"
            viewBox="0 0 1024 1024"
          >
            <path
              fill="currentColor"
              d="M938.666667 789.333333c8.533333-17.066667 17.066667-29.866667 25.6-46.933333 4.266667-4.266667 4.266667-8.533333 4.266666-12.8 4.266667-12.8 12.8-25.6 17.066667-38.4 4.266667-4.266667 4.266667-8.533333 4.266667-17.066667 4.266667-12.8 8.533333-25.6 12.8-34.133333 0-4.266667 4.266667-12.8 4.266666-17.066667 4.266667-12.8 4.266667-25.6 8.533334-38.4 0-4.266667 4.266667-12.8 4.266666-17.066666 4.266667-17.066667 4.266667-38.4 4.266667-55.466667 0-281.6-230.4-512-512-512s-512 230.4-512 512c0 17.066667 0 38.4 4.266667 55.466667 0 4.266667 0 12.8 4.266666 17.066666 0 12.8 4.266667 25.6 4.266667 38.4 0 4.266667 4.266667 12.8 4.266667 17.066667 4.266667 12.8 8.533333 25.6 12.8 34.133333 0 4.266667 4.266667 8.533333 4.266666 17.066667 4.266667 12.8 8.533333 25.6 17.066667 38.4 0 4.266667 4.266667 8.533333 4.266667 12.8 8.533333 17.066667 17.066667 29.866667 25.6 46.933333 89.6 140.8 247.466667 234.666667 426.666666 234.666667s337.066667-93.866667 430.933334-234.666667c-4.266667 0-4.266667 0 0 0zM507.733333 243.2c102.4 0 187.733333 85.333333 187.733334 187.733333 0 102.4-85.333333 187.733333-187.733334 187.733334s-187.733333-85.333333-187.733333-187.733334c0-102.4 85.333333-187.733333 187.733333-187.733333z m-311.466666 588.8c55.466667-123.733333 174.933333-204.8 311.466666-204.8s256 81.066667 311.466667 204.8c-81.066667 76.8-192 128-311.466667 128-119.466667-4.266667-230.4-51.2-311.466666-128z"
            ></path>
          </svg>
          <span class="info-value">
            所属人: {{ ducument.initiator || '-' }}
          </span>
        </div>
        <div class="info-row time-info">
          <span class="info-value">{{ ducument.startTime || '-' }}</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import { mapGetters } from 'vuex'
  export default {
    name: 'DocumentCard',
    props: {
      ducument: {
        type: Object,
        default: () => ({}),
      },
    },
    computed: {
      ...mapGetters('user', ['tokens']),
    },
    methods: {
      handleView() {
        const url = `${this.ducument.dmsUrl}${
          this.ducument.dmsUrl.indexOf('?') === -1 ? '?' : '&'
        }token=${this.tokens.token}&rtoken=${this.tokens.rtoken}`
        window.open(url, '_blank')
      },

      getTruncatedSummary(summary) {
        if (!summary) return ''
        return summary
      },

      /**
       * 根据索引获取标签颜色
       * @param {number} index - 数据索引
       * @returns {Object} 包含背景色和文字颜色的对象
       */
      getTagColor(index) {
        const colorSchemes = [
          { bg: '#e6f7ff', text: '#1890ff' },
          // { bg: '#f0f9ff', text: '#52c41a' },
          // { bg: '#f9f0ff', text: '#722ed1' },
          // { bg: '#fff7e6', text: '#fa8c16' },
        ]
        // 如果没有索引或索引无效，默认返回蓝色
        if (index === undefined || index === null) {
          return colorSchemes[0]
        }
        // 根据索引循环使用颜色方案
        const colorIndex = index % colorSchemes.length
        return colorSchemes[colorIndex]
      },
    },
  }
</script>

<style lang="scss" scoped>
  .ducument-item {
    position: relative;
    padding: 14px;
    margin-bottom: 8px;
    background: #ffffff;
    border-radius: 8px;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
    transition: box-shadow 0.3s, transform 0.2s;

    &:hover {
      box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
      transform: translateY(-2px);
    }
  }

  .ducument--header {
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
    margin-bottom: 6px;
  }

  .ducument--title-container {
    flex: 1;
    margin-right: 12px;
  }

  .ducument--title {
    margin: 0;
    font-size: 14px;
    font-weight: 500;
    line-height: 1.6;
    color: #0f4fff;
    cursor: pointer;
    transition: color 0.2s;

    &:hover {
      color: #40a9ff;
      text-decoration: underline;
    }
  }

  .ducument-tag {
    padding: 4px 12px;
    margin-left: 8px;
    font-size: 12px;
    font-weight: 500;
    white-space: nowrap;
    border-radius: 4px;
  }
  .ducument-code {
    padding: 4px 12px;
    margin-left: 8px;
    font-size: 12px;
    font-weight: 500;
    color: #4871b8;
    white-space: nowrap;
    background-color: #dbeafe;
    border-radius: 4px;
  }

  .ducument--info {
    margin-top: 8px;
  }

  .info-item {
    font-size: 11px;
  }

  .flex-space-between {
    display: flex;
    align-items: center;
  }

  .info-row {
    display: flex;
    gap: 2px;
    align-items: center;
    margin-right: 20px;
  }

  .info-row:last-child {
    margin-right: 0;
  }

  .time-info {
    margin-left: auto;
  }

  .info-icon {
    color: #909399;
  }

  .info-value {
    color: #909399;
  }

  .ducument--ai-summary {
    max-width: 80%;
    overducument: hidden;
    font-size: 12px;
    line-height: 1.5;
    color: #303133;
    text-overducument: ellipsis;
    white-space: nowrap;
  }
</style>
